<template lang="html">
  <div>
    <h-section-header back="/dashboard">
      {{client.first_name}}'s custom habits
    </h-section-header>
    <div class="card-rows">
      <habit :client="client" v-for="habit in habits" :key="habit.id" :habit="habit" />
    </div>
    <div class="card card--white" v-if="!loading && habits.length == 0">
      <div class="card--container">
        Doesn't look like {{client.first_name}} has set any custom habits.
      </div>
    </div>

    <!-- <h-section-header>
      Currently assigned
    </h-section-header>
    <div class="card card--transparent" v-if="!loading && assignedHabits.length == 0">
      <div class="card--container">
        {{client.first_name}} has no assigned habits. 
      </div>
    </div> -->
    <h-section-header>Habit History</h-section-header>
      <div class="card card--transparent full-width">
      <h1 style="text-align: center">Percent of Completed Exercises</h1>
      <completed style="height: 30vh; min-height: 200px" :userId="client.id" />
    </div>
    <div v-infinite-scroll="findMoreExercises" :infinite-scroll-disabled="loadingExercises" infinite-scroll-distance="800">
      <div  class="card-rows exercise-history">
        <div v-for="exercise in exerciseHistory" 
          :key="exercise.id" 
          class="card exercise-card" 
          :class="{'missed': !exercise.completed_at}"
          :style="{'background-color': exercise.color}">
          <div class="card--container">
            <div class="row space-between">
              <div class="created">{{created(exercise)}}</div>
              <div v-if="exercise.completed_at" class="row">
                Completed
              </div>
              <div v-else>Missed</div>
            </div>
            <h4 class="small-top">{{exercise.short_description}}</h4>
            <div>{{exercise.description}}</div>
            <div v-if="exercise.previous_notes.length > 0">
            <h4 class="small-top">Previous Notes</h4>
            <div v-for="note in exercise.previous_notes" :key="note">
              {{note}}
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import store from "@/services/api/store";
import habit from "./habit";
import completed from "@/components/charts/completed";
import Paginator from "@/services/api/paginator";
import moment from "moment";

const CLIENT_HABIT_STORE = "CoachClientHabits";

export default {
  props: ["client"],
  components: { habit, completed },
  data() {
    return {
      habits: [],
      loading: false,
      assignedHabits: [],
      exerciseHistory: [],
      loadingExercises: false
    }
  },
  created() {
    this.loading = true;
    store.findAll(CLIENT_HABIT_STORE, {client: this.$route.params.id}, {force: true})
      .then(r => {
        this.habits = r;
      }).finally(() => {
        this.loading = false;
      });
    
    this.paginator = new Paginator("CoachClientExercises", {user: this.client.id})
    this.findMoreExercises();
  },
  methods: {
    findMoreExercises() {
      if (this.paginator.finished || this.loadingExercises) {
        return
      }
      this.loadingExercises = true;
      this.paginator.next()
        .then(exercises => {
          this.exerciseHistory = [...this.exerciseHistory, ...exercises];
        }).finally(() => {
          this.loadingExercises = false;
        });
    },
    created(exercise) {
      return moment(exercise.created_at).format("ll");
    }
  }
}
</script>

<style lang="less">
.exercise-history {
  .exercise-card {
    color: white;
    & + .missed {
      filter: brightness(0.8);
    }
    i {
      width: 1.25em;
      font-size: 18px;
    }
  }
}
</style>
